import angular from "angular"
import { configureDebug } from "./debug.config";

/** A module that will be used to configure the web app externally. */
export const EnvironmentModule = angular.module("apex.environment", [])
    .config(configureDebug)
    .name;
